module.exports = __webpack_public_path__ + "img/pflaumenwein.e905e54d.jpg";